import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../utils/cn';

export interface FilterOption {
    value: string;
    label: string;
}

interface FilterSelectProps {
    value: string;
    options: FilterOption[];
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
}

/**
 * 筛选器下拉选择组件 - 仿夸克网盘设计
 */
const FilterSelect: React.FC<FilterSelectProps> = ({
    value,
    options,
    onChange,
    placeholder = '全部',
    className,
}) => {
    return (
        <div className={cn('relative inline-block', className)}>
            <select
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className={cn(
                    'appearance-none pl-2.5 sm:pl-3 pr-7 sm:pr-8 py-2 text-xs font-medium rounded-lg',
                    'bg-gray-50 border border-gray-200 text-gray-700',
                    'hover:bg-gray-100 hover:border-gray-300',
                    'focus:outline-none focus:ring-2 focus:ring-teal-500/20 focus:border-teal-400',
                    'transition-all duration-200 cursor-pointer'
                )}
            >
                {options.map((option) => (
                    <option key={option.value} value={option.value} style={{ fontSize: '14px' }}>
                        {option.label}
                    </option>
                ))}
            </select>
            <ChevronDown
                size={14}
                className="absolute right-1.5 sm:right-2.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
            />
        </div>
    );
};

export default FilterSelect;
